import pino, { type Logger as PinoLogger } from "pino";
import type { Logger, LogLevel } from "../data-model/ports.js";

export type { Logger, LogLevel } from "../data-model/ports.js";

function adapt(p: PinoLogger): Logger {
  return {
    trace: (a: object | string, b?: string) => (typeof a === "string" ? p.trace(a) : p.trace(a, b)),
    debug: (a: object | string, b?: string) => (typeof a === "string" ? p.debug(a) : p.debug(a, b)),
    info: (a: object | string, b?: string) => (typeof a === "string" ? p.info(a) : p.info(a, b)),
    warn: (a: object | string, b?: string) => (typeof a === "string" ? p.warn(a) : p.warn(a, b)),
    error: (a: object | string, b?: string) => (typeof a === "string" ? p.error(a) : p.error(a, b)),
    child: (bindings: object) => adapt(p.child(bindings)),
  };
}

/**
 * Build a pino-backed {@link Logger} at the given level (default `"silent"`).
 * Pass it to `createDownloader({ logger })`, or use the `logLevel` shortcut on
 * `createDownloader` to skip constructing one.
 */
export function createLogger(opts: { level?: LogLevel } = {}): Logger {
  return adapt(pino({ level: opts.level ?? "silent" }));
}

/** A {@link Logger} that discards everything — the default when no logger is configured. */
export const silentLogger: Logger = createLogger({ level: "silent" });
